import { orderConfirmationPageContainerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

Object.assign(orderConfirmationPageContainerStyles, {
    ...orderConfirmationPageContainerStyles,
    container: {
        offsetCss: css`
            justify-content: flex-end;
        `,
    },
    headerGridItem: {
        css: css`
            order: 1;
        `,
        width: 12,
    },
    accountSignUpGridItem: {
        css: css`
            order: 2;
        `,
        width: 12,
    },
    orderInformationGridItem: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 3;
                    `,
                    css`
                        order: 3;
                    `,
                    css`
                        order: 3;
                    `,
                    css`
                        order: 3;
                    `,
                    css`
                        order: 3;
                    `,
                ])}
        `,
        width: [12, 12, 12, 12, 12],
    },
    orderTotalGridItem: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 4;
                    `,
                    css`
                        order: 4;
                    `,
                    css`
                        order: 4;
                    `,
                    css`
                        order: 4;
                    `,
                    css`
                        order: 4;
                    `,
                ])}
        `,
        width: [12, 12, 6, 6, 6],
    },
    productListGridItem: {
        css: css`
            order: 3;
        `,
        width: [12, 12, 12, 12, 12],
    },
});
